import { Carousel } from "@mantine/carousel";
import { em, Grid, Paper } from "@mantine/core";
import { useRef } from "react";
import Autoplay from 'embla-carousel-autoplay';
import carouselImage1 from "/assets/images/feb_images/image_1_red.jpg";
import carouselImage2 from "/assets/images/feb_images/image_2_red.jpg";
import carouselImage3 from "/assets/images/feb_images/image_3_red.jpg";
import carouselImage4 from "/assets/images/feb_images/image_4_red.jpg";
import carouselImage5 from "/assets/images/feb_images/image_5_red.jpg";
import carouselImage6 from "/assets/images/feb_images/image_6.jpeg";
import colors from "../../../utils/styles";
import { useMediaQuery } from "@mantine/hooks";

const CarouselSection = () => {
    const carouselImages = [
        carouselImage1,
        carouselImage2,
        carouselImage3,
        carouselImage4,
        carouselImage5,
        carouselImage6
    ];
    const autoplay = useRef(Autoplay({ delay: 5000 }));
    const isDesktop = useMediaQuery(`(max-width: ${em(1024)})`);

    return (<>
        <Grid py="xl" gutter={0} style={{ marginBottom: isDesktop ? '-5%' : '0px' }}>
            <Grid.Col span={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Carousel
                    slideSize="100%"
                    slideGap="md"
                    controlsOffset="lg"
                    controlSize={30}
                    loop
                    withIndicators
                    styles={{
                        indicator: {
                            backgroundColor: colors.appYellow,
                            color: colors.appWhite,
                        },
                        root: {
                            flex: 1,
                            width: '100%',
                        },
                    }}
                    plugins={[autoplay.current]}
                    onMouseEnter={autoplay.current.stop}
                    onMouseLeave={autoplay.current.reset}
                >
                    {carouselImages.map((image, index) => (
                        <Carousel.Slide key={`carousel-slide-${index}`}>
                            <Paper
                                shadow="md"
                                p="xl"
                                radius="md"
                                style={{
                                    backgroundImage: `url(${image})`,
                                    height: 'clamp(220px, 45vw, 450px)',
                                    width: '100%',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            ></Paper>
                        </Carousel.Slide>
                    ))}
                </Carousel>
            </Grid.Col>
        </Grid>
    </>
    )
}

export default CarouselSection;